export const authRedirectGate = {
  suppress401Redirect: false,
};
